import styled from 'styled-components';
import { mediaDesktop } from '../../breakpoints';
import theme from '../theme';

export const CollectionSalesInfoContainer = styled.div`
  display: flex;
  border: 1px solid ${theme.colors.darkBorder};
  background: transparent;
  color: #fff;
  border-radius: 9px;
  flex-wrap: wrap;
  max-width: 100%;
  ${mediaDesktop} {
    max-width: 100%;
    width: fit-content;
    border: 1px solid ${theme.colors.white};
    padding: 16px 4px;
    border-radius: 13px;
  }
`;

export const CollectionSalesInfoItem = styled.div`
  display: grid;
  letter-spacing: 1px;
  font-family: ${theme.fonts.primary};
  text-transform: uppercase;
  text-align: center;
  width: 50%;
  padding: 15px 0;
  
  &:nth-of-type(1) {
    border-right: 1px solid ${theme.colors.darkBorder};
    border-bottom: 1px solid ${theme.colors.darkBorder};
  }
  &:nth-of-type(2) {
    border-bottom: 1px solid ${theme.colors.darkBorder};
  }
  &:nth-of-type(3) {
    border-right: 1px solid ${theme.colors.darkBorder};
  }
  
  ${mediaDesktop} {
    padding: 0 16px;
    grid-gap: 5px;
    width: 210px;
    border-top: none !important;
    border-bottom: none !important;
    border-right: 1px solid ${theme.colors.white} !important;
    &:last-of-type {
      border-right: none !important;
    }
  }
`;

export const CollectionSalesItemValue = styled.p`
  font-weight: 500;
  line-height: 24px;
  font-size: 20px;
  ${mediaDesktop} {
    font-size: 24px;
    line-height: 24px;
  }
`;

export const CollectionSalesItemHeading = styled.h4`
  font-weight: normal;
  font-size: 12px;
  ${mediaDesktop} {
    font-size: 15px;
  }
`;
